import { render, staticRenderFns } from "./loginHeader.vue?vue&type=template&id=28147f2c&scoped=true"
import script from "./loginHeader.vue?vue&type=script&lang=js"
export * from "./loginHeader.vue?vue&type=script&lang=js"
import style0 from "./loginHeader.vue?vue&type=style&index=0&id=28147f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28147f2c",
  null
  
)

export default component.exports